export const BIFROST_HEADER = 'X-Bifrost-Authorization'
export const COOKIE_KEY_AU = 'Valgrind-AU'
export const COOKIE_KEY_AI = 'Valgrind-AI'
export const SESSION_TIMEOUT = 2000

export const AUTH_INTERNAL_SESSION_HOST = process.env.AUTH_INTERNAL_SESSION_HOST
export const ORIGIN_URL = 'https://www.serasa.com.br' // process.env.NEXT_PUBLIC_HOST as string
